module.exports = __webpack_public_path__ + "img/Intersection 4@3x.91906822.png";